import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorState {
  message: string | null;
  statusCode: number | null;
}

const initialState: ErrorState = {
  message: null,
  statusCode: null,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<ErrorState>) => {
      state.message = action.payload.message;
      state.statusCode = action.payload.statusCode;
    },
    clearError: (state) => {
      state.message = null;
      state.statusCode = null;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;

export default errorSlice.reducer;